import React from 'react'
import { NavLink } from 'react-router-dom'
import { Disclosure } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import { getInitialStakingData } from 'app/features/earn/earnSlice'
import { connectWallet, disconnectWallet } from 'app/features/web3/web3Slice'
import { useAppDispatch, useAppSelector } from 'app/hooks/hooks'
import { RootState } from 'app/store'
import { navigationData } from 'app/utils/navigation'
import { classNames } from 'app/utils/tailwind'

function NavBar() {
  const dispatch = useAppDispatch()
  const { walletStatus } = useAppSelector((state: RootState) => state.web3)

  const connect = () => {
    dispatch(connectWallet())
      .unwrap()
      .then(() => {
        dispatch(getInitialStakingData())
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const disconnect = () => {
    dispatch(disconnectWallet()).catch((error) => {
      console.log(error)
    })
  }

  const connected = walletStatus === 'connected'

  return (
    <Disclosure as="nav" className="flex-none bg-ebony-clay-500">
      {({ open }) => (
        <>
          <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 ">
            <div className="flex justify-between h-16">
              <div className="flex">
                <div className="flex items-center mr-2 -ml-2 md:hidden">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-white hover:bg-ebony-clay-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block w-6 h-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block w-6 h-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="flex items-center flex-shrink-0">
                  <img
                    className="block w-auto h-8 md:hidden"
                    src="img/trimmed.svg"
                    alt="Workflow"
                  />
                  <img
                    className="hidden w-auto h-8 md:block"
                    src="img/logo.svg"
                    alt="Workflow"
                  />
                </div>
                <div className="hidden md:ml-6 md:flex md:items-center md:space-x-4">
                  {navigationData.map((item) =>
                    item.name !== 'Buy' && item.name !== 'Bridge' ? (
                      <NavLink
                        key={item.name}
                        to={item.href}
                        exact={item.name === navigationData[0].name}
                        className="px-3 py-2 text-sm font-medium text-gray-300 rounded-md hover:bg-ebony-clay-700 hover:text-white"
                        activeClassName={classNames(
                          'bg-ebony-clay-500 text-white'
                        )}
                        // target={item.name === 'Buy' ? '_blank' : undefined}
                        // aria-current={
                        //   isCurrentRoute(item, currentRoute) ? 'page' : undefined
                        // }
                      >
                        {item.name}
                      </NavLink>
                    ) : (
                      <a
                        key={item.name}
                        href={item.href}
                        className="px-3 py-2 text-sm font-medium text-gray-300 rounded-md hover:bg-ebony-clay-700 hover:text-white"
                        // target={item.name === 'Buy' ? '_blank' : undefined}
                      >
                        {item.name}
                      </a>
                    )
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className="relative inline-flex items-center px-4 py-2 text-sm font-bold text-white border border-transparent rounded-md shadow-sm bg-spring-green-600 hover:bg-spring-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-spring-green-600"
                    onClick={() => {
                      if (connected) {
                        disconnect()
                        return
                      }
                      connect()
                    }}
                  >
                    <span>
                      {connected ? 'Disconnect Wallet' : 'Connect Wallet'}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navigationData.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className="px-3 py-2 text-sm font-medium text-gray-300 rounded-md hover:bg-ebony-clay-700 hover:text-white"
                  activeClassName={classNames('bg-ebony-clay-500 text-white')}
                  // aria-current={
                  //   isCurrentRoute(item, currentRoute) ? 'page' : undefined
                  // }
                >
                  <Disclosure.Button className="font-bold">
                    {item.name}
                  </Disclosure.Button>
                </NavLink>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

export default NavBar
